<template>
  <div class="xcar pb-0 mb-0">
    <v-btn small class="ma-0" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <h4 class="text-primary text-center mt-0 pt-0 mb-0">
      ASIGNACIONES DE PROGRAMAS DE LA SEDE POR CONVENIO
    </h4>

    <v-row dense class="ml-2">
      <v-col cols="2">
        <v-combobox
          v-model="filtros.gestion"
          :items="gestiones"
          label="Gestion"
          :loading="loadinggestion"
          :disabled="loading"
          hide-details
          outlined
          dense
        ></v-combobox>
      </v-col>
      <v-col cols="2">
        <v-combobox
          v-model="filtros.mes"
          :items="meses"
          label="Mes"
          :loading="loadingmes"
          :disabled="loading"
          hide-details
          outlined
          dense
        ></v-combobox>
      </v-col>
      <v-col cols="2">
        <v-combobox
          v-model="filtros.tipoasignacion"
          :items="tiposasignacion"
          :disabled="loading"
          label="Ver tipo asignacion"
          hide-details
          outlined
          dense
        ></v-combobox>
      </v-col>
    </v-row>
    <p class="text-center text-danger pa-0" v-if="msg">
      <b>{{ msg }}</b>
    </p>
    <v-progress-linear indeterminate v-if="loading" class="mt-2" />
    <!-- <div class="text-center ma-0" v-if="loading">
      <div style="display: inline-block;" v-if="loading" class="loader"></div>
    </div> -->

    <div><AAsignacionTablaS ref="asignacionestablas" v-on:dataloaded="dataloaded" /></div>
  </div>
</template>

<script>
  import AAsignacionTablaS from '@/components/AAsignacionTablaS.vue';

  export default {
    data() {
      return {
        gestiones: [2024,2023, 2022, 2021, 2020, 2019, 2018],
        meses: [
          { id: 1, text: 'Enero' },
          { id: 2, text: 'Febrero' },
          { id: 3, text: 'Marzo' },
          { id: 4, text: 'Abril' },
          { id: 5, text: 'Mayo' },
          { id: 6, text: 'Junio' },
          { id: 7, text: 'Julio' },
          { id: 8, text: 'Agosto' },
          { id: 9, text: 'Septiembre' },
          { id: 10, text: 'Octubre' },
          { id: 11, text: 'Noviembre' },
          { id: 12, text: 'Diciembre' },
        ],
        tiposasignacion: [
          { id: 1, text: 'Asignacion' },
          { id: 2, text: 'Inscritos' },
        ],
        loadinggestion: false,
        loadingmes: false,
        filtros: {
          gestion: null,
          mes: null,
          tipoasignacion: null,
        },
        buscar: '',
        datos: [],
        loading: false,
        msg: '',
      };
    },
    watch: {
      'filtros.gestion': function() {
        this.resetcache();
        this.obtenerasignaciones();
      },
      'filtros.mes': function() {
        this.resetcache();
        this.obtenerasignaciones();
      },
      'filtros.tipoasignacion': function() {
        if (this.filtros.tipoasignacion) this.setipoasignacion();
      },
      '$store.state.CARGO.sede': function() {
        this.resetcache();
        this.obtenerasignaciones();
      },
      '$store.state.convenio': function() {
        if (this.$store.state.convenio) {
          this.obtenerasignaciones();
        }
      },
    },
    components: { AAsignacionTablaS },
    methods: {
      dataloaded() {
        this.loading = false;
      },
      defaultdata() {
        let date = new Date();
        let anio = date.getFullYear();
        let mes = date.getMonth() + 1;
        this.filtros.tipoasignacion = this.tiposasignacion[0];
        this.filtros.gestion = '' + anio;
        this.filtros.mes = this.meses.find((x) => x.id == mes);
      },
      setipoasignacion() {
        let tipoasignacion = this.filtros.tipoasignacion;
        this.$refs.asignacionestablas.setipoasignacion(tipoasignacion);
      },
      resetcache() {
        this.$refs.asignacionestablas.resetcache();
      },
      obtenerasignaciones() {
        if (!this.filtros.gestion) return;
        if (!this.filtros.mes) return;
        if (this.loading) return;
        this.loading = true;
        let tipoasignacion = this.filtros.tipoasignacion;
        let g = this.filtros.gestion;
        let m = this.filtros.mes.id;
        let convenio = null;
        if (this.$store.state.convenio) convenio = this.$store.state.convenio.id;
        this.$refs.asignacionestablas.obtenerasignaciones(g, m, tipoasignacion, convenio);
      },
    },
    mounted() {
      this.defaultdata();
      this.obtenerasignaciones();
    },
  };
</script>
